/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { loggedInGuard } from '@/router/middleware'
import routeNames from '@/router/routeNames'

import type { StrictRouteConfig } from 'types/router'

const NoProgramsPage = () => import('@/pages/Login/NoProgramsPage.vue')
const LoginPage = () => import('@/pages/Login/LoginPage.vue')
const SSORedirectPage = () => import('@/pages/Login/SSORedirectPage.vue')

const routeConfig: StrictRouteConfig[] = [
  {
    path: '/login',
    name: routeNames.LOGIN,
    component: LoginPage,
    beforeEnter: loggedInGuard,
    meta: { hideSidebar: true, hideNavbar: true, title: 'Login' },
  },
  {
    path: '/no-programs',
    name: routeNames.NO_PROGRAMS,
    component: NoProgramsPage,
    meta: { hideSidebar: true, hideNavbar: true, title: 'No Programs' },
  },
  {
    path: '/sso-redirect',
    name: routeNames.SSO_REDIRECT,
    component: SSORedirectPage,
    meta: { hideSidebar: true, hideNavbar: true, title: 'Redirecting...' },
  },
]

export default routeConfig
